import(/* webpackMode: "eager", webpackExports: ["StackClient"] */ "/vercel/path0/app/stack/stack-client.tsx");
